
import { profileQueryService } from "./profileQueryService";
import { profileMutationService } from "./profileMutationService";
import { profileConsolidatedService } from "./profileConsolidatedService";

// Export individual services
export { profileQueryService } from "./profileQueryService";
export { profileMutationService } from "./profileMutationService";
export { profileConsolidatedService } from "./profileConsolidatedService";

/**
 * Consolidated profile service that combines query and mutation services
 */
export const profileService = {
  // Query methods
  getUserProfile: profileQueryService.getUserProfile,
  
  // Mutation methods
  createUserProfile: profileMutationService.createUserProfile,
  
  // Consolidated methods
  getConsolidatedProfileData: profileConsolidatedService.getConsolidatedProfileData,
};

// Export default for consistency with other service modules
export default profileService;
